module.exports = __webpack_public_path__ + "img/image-map-1-4b3a7dc0.png";